import { createFileRoute, redirect } from '@tanstack/react-router';

import { currentCohort } from '@/cohort-content';
import { PersonalDetails } from '@/features/registration';

export const Route = createFileRoute('/$hci_shortname/personal-details')({
	beforeLoad: async () => {
		if (!currentCohort) {
			throw redirect({
				to: '/oops',
			});
		}
	},
	component: () => <PersonalDetails cohort={currentCohort} />,
	head: () => ({
		meta: [
			{
				title: `Your details | ${currentCohort.name}`,
			},
		],
	}),
});
